import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { TModalVPosition, TModalWidthType } from './types';
import { PORTAL_CONTAINER_ID } from './constants';

const EXPANSION_TO_WIDTH_CSS: Record<
  TModalWidthType,
  FlattenSimpleInterpolation
> = {
  'full-width': css`
    width: 100%;
  `,
  'fit-content': css`
    width: fit-content;
  `,
  sm: css`
    width: 320px;
  `,
  md: css`
    width: 576px;
  `,
  lg: css`
    width: 960px;
  `,
};

const VPOSITION_TO_CSS: Record<TModalVPosition, FlattenSimpleInterpolation> = {
  top: css`
    align-self: flex-start;
    margin-top: var(--l-margin);
    margin-bottom: var(--l-margin);
  `,
  center: css``,
  bottom: css`
    align-self: flex-end;
    margin-bottom: var(--l-margin);
    margin-top: var(--l-margin);
  `,
};

export const ModalContentContainer = styled.div<{
  widthType: TModalWidthType;
  vPosition: TModalVPosition;
}>`
  --l-margin: 100px;

  display: flex;
  flex-direction: column;
  z-index: 14;
  padding: 10px 20px;
  background-color: #fff;
  border-radius: var(--radius-24);
  height: fit-content;
  box-shadow: var(--elevation-medium);
  transition: transform var(--transition-normal);

  ${(p) => EXPANSION_TO_WIDTH_CSS[p.widthType as TModalWidthType]}
  ${(p) => VPOSITION_TO_CSS[p.vPosition as TModalVPosition]}
  > h3 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > button {
      margin-left: auto;
    }
  }
`;

export const Backdrop = styled.div.attrs({ id: PORTAL_CONTAINER_ID })`
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 12;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity var(--transition-normal);
  overflow-y: scroll;

  &[data-modal-state='closed'] {
    display: none;

    ${ModalContentContainer} {
      display: none;
    }
  }

  &[data-modal-state='opening'] {
    opacity: 0;

    ${ModalContentContainer} {
      transform: translateY(-30%);
    }
  }

  &[data-modal-state='open'] {
    opacity: 1;

    ${ModalContentContainer} {
      transform: translateY(0%);
    }
  }

  &[data-modal-state='closing'] {
    opacity: 0;

    ${ModalContentContainer} {
      transform: translateY(-30%);
    }
  }
`;

export const ModalFooterControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-l);
`;

export const InputGroup = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;

  > label {
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 700;
  }

  > input {
    height: 45px;
    padding: 6px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: var(--radius-4);

    :disabled {
      cursor: not-allowed;
    }
  }
`;

// TODO: remove once we get rid of tagify.
export const InputGroupTagifyPatch = styled(InputGroup)`
  > .trevor-tagify-input {
    min-height: 34px;
    height: initial;
    text-transform: lowercase;
    padding: 6px 12px;

    > .tagify__tag:hover {
      border: 1px solid #ddd;
      background: #e5e5e5;
    }

    > .tagify__input {
      width: 100%;
    }
  }

  .tagify__tag {
    border: 1px solid #ddd;
    border-radius: 18px;
    color: #14171a !important;
    background: #e5e5e5;
  }
`;
